// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"
import { useState, useEffect } from "react"
import { InputText } from "primereact/inputtext"
import useDebounce from "../../helpers/useDebounce"
import { Button } from "../../../Button"

const TableInputText = ({
  onChange
}: any) => {
  const [value, setValue] = useState()
  const [searchTerm, setSearchTerm] = useState()
  const debouncedSearchTerm = useDebounce(searchTerm, 500)
  useEffect(() => {
    onChange(debouncedSearchTerm)
  }, [debouncedSearchTerm])
  const searchItem = (e: any) => {
    setSearchTerm(e.trim())
  }
  return _jsxs(
    "div",
    {
      className: "p-inputgroup",
      children: [
        _jsxs(
          "span",
          {
            className: "p-input-icon-right",
            children: [
              value
                ? _jsx(
                    "i",
                    {
                      className: "pi pi-times",
                      style: { cursor: "pointer" },
                      onClick: () => {
                        // @ts-expect-error TS(2345): Argument of type '""' is not assignable to paramet... Remove this comment to see the full error message
                        setValue("")
                        searchItem("")
                      },
                    },
                    void 0
                  )
                : null,
              _jsx(
                InputText,
                {
                  id: "in",
                  value,
                  style: { width: "100%" },
                  onChange: (e: any) => {
                    setValue(e.target.value)
                  },
                  className: "p-column-filter",
                },
                void 0
              ),
            ],
          },
          void 0
        ),
        _jsx(
          Button,
          {
            iconLibrary: "fas",
            icon: "search",
            className: "--no-border-radius",
            onClick: () => searchItem(value),
          },
          void 0
        ),
      ],
    },
    void 0
  );
}
export default TableInputText
